import { takeEvery, call, put } from 'redux-saga/effects'
import { REHYDRATE } from 'redux-persist/constants'
import api from '../middleware/api'
import * as action from '../actions'
import { persistor } from '../store'

function* watchForUserLogout() {
  yield takeEvery(action.USER_LOGGED_OUT, () => persistor.purge())
}

function* watchForRehydrate() {
  yield takeEvery(REHYDRATE, function* x({ payload }) {
    yield call(api.set_axios, payload.user)
    yield put(action.loadCampaigns(payload.user))
    yield put(action.loadUserProfile(payload.user))
  })
}

export default [watchForUserLogout, watchForRehydrate]



// WEBPACK FOOTER //
// ./src/sagas/app.js